
import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  getBusinessStoreEvent,
  addBusinessStoreEvent,
  updateBusinessStoreEvent,
} from '@/api/businessStoreEvent';
import { ElForm } from 'element-ui/types/form';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) private formIdx!: any;

  mounted() {
    this.init();
  }

  private loading = true;

  private formData: any = {
    title: '',
    descript: '',
    startDate: '',
    endDate: '',
    discountPercent: 1,
    dateRange: [],
  }

  private rules = {
    title: [
      { required: true, message: '이벤트명을 입력해 주세요.', trigger: ['blur', 'change'] },
    ],
    discountPercent: [
      { required: true, message: '할인율을 입력해 주세요.', trigger: ['blur', 'change'] },
    ],
    dateRange: [
      { required: true, message: '이벤트 기간을 입력해 주세요.', trigger: ['blur', 'change'] },
    ],
  }

  private init() {
    if (this.formIdx) {
      getBusinessStoreEvent(this.formIdx).then((res: any) => {
        this.loading = false;
        this.formData = {
          ...this.formData,
          ...res.data,
        };
        if (res.data.startDate && res.data.endDate) {
          this.formData.dateRange = [res.data.startDate, res.data.endDate];
        }
      });
    } else {
      this.loading = false;
    }
  }

  private handleClickSave() {
    (this.$refs.formRef as ElForm).validate((valid: boolean) => {
      if (valid) {
        if (this.formIdx) {
          updateBusinessStoreEvent(this.formIdx, this.formData).then(() => {
            this.$message.success('이벤트가 수정되었습니다.');
            this.$emit('save');
          });
        } else {
          addBusinessStoreEvent(this.formData).then(() => {
            this.$message.success('이벤트가 추가되었습니다.');
            this.$emit('save');
          });
        }
      }
    });
  }

  /* eslint-disable */
  private handleChangeDateRange() {
    if (this.formData.dateRange && this.formData.dateRange.length === 2) {
      this.formData.startDate = this.formData.dateRange[0];
      this.formData.endDate = this.formData.dateRange[1];
    } else {
      this.formData.startDate = '';
      this.formData.endDate = '';
    }
  }
}
